import React from 'react';
import { FormFieldContainer } from './FormFieldContainer';
import { ConditionalFields } from '../formFields';
import { Seperator } from '@/components/ats/Seperator';

export const FormItem = ({ field = {}, formik = {} }) => {
  // Handle null or undefined fields
  if (!field || field === null) {
    return null;
  }

  // Handle Seperators
  if (field?.type === 'seperator') {
    return <Seperator {...field} />;
  }

  // Handle custom fields:
  if (field?.type === 'function' && field?.function) {
    return <field.Field formik={formik} {...field?.props} />;
  }

  // Handle custom fields:
  if (field?.type === 'invisible') {
    return <></>;
  }

  // Handle conditional rendering:
  if (field?.isConditional) {
    return <ConditionalFields field={field} formik={formik} />;
  }

  // Handle custom fields:
  if (field?.type === 'custom' && field.Field) {
    return <field.Field formik={formik} {...field?.props} />;
  }

  // Handle wrappers and non-wrappers consistently:
  const content = (
    <>
      {field.fields?.map((subField, subIndex) => {
        // Handle conditional rendering for wrapper fields
        if (subField?.isConditional) {
          return (
            <ConditionalFields
              key={subIndex}
              field={subField}
              formik={formik}
            />
          );
        }
        return (
          <React.Fragment key={subIndex}>
            <FormItem field={subField} formik={formik} />
          </React.Fragment>
        );
      })}
      {!field.fields && <FormFieldContainer item={field} formik={formik} />}
    </>
  );

  // Use a wrapper component if available:
  return field.Wrapper ? (
    <field.Wrapper {...field.wrapperProps}>{content}</field.Wrapper>
  ) : (
    content
  );
};
